export default "__VITE_ASSET__BuKvI7So__"